module.exports = __webpack_public_path__ + "static/media/slider-img4.6931d0d6.png";